import { HTTPClientError } from './HTTPClientError';
export class HTTPUnauthorizedError extends HTTPClientError {
    constructor() {
        super(401 /* Unauthorized */, 'Unauthorized');
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
